import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import Link from '../../../components/Link';

import saraLogoWhite from '../../../../../public/images/uncompressed/sara-logo-white.png';

import s from './Portfolio.scss';

class Portfolio extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/"
                >
                  <span itemProp="name">Home</span>
                </Link>
                <meta content="0" itemProp="position" />
              </li>
              <li>Portfolio</li>
            </ul>
          }
          header="Portfolio"
          subHeader="Websites | Mobile Apps | APIs"
        />

        <section className={s.featuredProjects}>

          <div className={s.revvyProjectContainer}>
            <div className={s.revvyProject}>
              <div className={s.laptopPreview}>
                <img
                  alt="Revvy Icon"
                  src="/images/uncompressed/revvy-mockup-macbook2019.png"
                />
              </div>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <img
                    alt="Revvy Icon"
                    className={s.revvyIcon}
                    src="/images/uncompressed/revvy-icon-192x192.png"
                  />
                  <h3>Revvy</h3>
                </div>
                <h4>Product reviews you can trust</h4>
                <div className={s.tags}>
                  <div className={s.tag}>Website</div>
                  <div className={s.tag}>Mobile App</div>
                </div>
                <p>
                  Revvy is a product review startup designed to help you make
                  more informed product purchasing decisions in a fun, social
                  way.
                </p>
                <Link to="/portfolio/revvy">View Case Study</Link>
              </div>
            </div>
          </div>

          <div className={s.shadowerProject}>
            <div className={s.infoContainer}>
              <div className={s.logoContainer}>
                <svg
                  clipRule="evenodd"
                  fillRule="evenodd"
                  strokeLinejoin="round"
                  strokeMiterlimit="1.414"
                  viewBox="0 0 566 645"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    // eslint-disable-next-line
                    d="M0.026,214.839c0.001,-118.531 126.797,-214.762 282.974,-214.762c155.629,0 281.915,95.35 282.967,213.276l0.007,0l0,1.486l0,0l0,213.276l-0.007,-0.007c0.005,0.498 0.007,0.995 0.007,1.493c0,118.53 -126.796,214.762 -282.974,214.762c-156.282,0 -282.973,-96.151 -282.974,-214.762c0,0 0,0 0,0c0,0 0,-214.762 0,-214.762l0,0Zm495.169,71.189l-0.704,-71.013c0,-88.647 -94.688,-160.686 -211.491,-160.686c-116.725,0 -211.491,71.922 -211.491,160.51c0,88.647 94.687,160.509 211.491,160.51l0,-53.129c78.141,0 141.487,48.076 141.487,107.381c0,59.265 -63.398,107.381 -141.487,107.381c-78.14,0 -141.486,-48.075 -141.487,-107.381l70.501,0l-70.501,0c0,-13.839 0,-28.731 0,-28.731l-0.007,-0.004c-26.607,-11.682 -50.476,-26.557 -70.695,-43.937l-0.006,-0.004c-0.259,5.295 0.066,68.079 0.073,74.674c0.001,88.649 95.32,158.512 212.122,158.512c116.725,0 211.491,-71.922 211.491,-160.51c0,-88.646 -94.687,-160.509 -211.491,-160.51l0,53.129c-78.141,0 -141.487,-48.076 -141.487,-107.381c0,-59.265 63.398,-107.381 141.487,-107.381c77.487,0 140.426,47.275 141.474,105.895l0.013,0l0,1.486l0,0l0,27.245l9.114,5.664c19.945,9.534 38.211,20.905 54.386,33.801l7.208,4.479Zm-212.195,89.699l0,53.874c-24.543,0 -48.355,-2.371 -71.061,-6.829c0.045,2.643 0.075,5.071 0.075,6.829c0.001,29.755 31.782,53.875 70.986,53.875c39.178,0 70.986,-24.141 70.986,-53.875c0,-29.754 -31.781,-53.874 -70.986,-53.874Zm70.992,-160.888l-0.006,0c0,-29.754 -31.781,-53.874 -70.986,-53.874c-39.178,0 -70.986,24.14 -70.986,53.874c0,29.754 31.781,53.874 70.986,53.875l0,-53.875c24.552,0 48.374,2.373 71.088,6.834c-0.047,-2.511 -0.083,-4.911 -0.096,-6.834Z"
                    fill="rgba(50,50,50,1)"
                  />
                </svg>
                <h3>Shadower</h3>
              </div>
              <h4>Skill shadowing in real life</h4>
              <div className={s.tags}>
                <div className={s.tag}>Web App</div>
                <div className={s.tag}>React</div>
              </div>
              <p>
                Shadower is an online platform that helps amateurs find experts
                to shadow in real life. Our mission is to reimagine how
                education works in an age when experience and connections matter
                most.
              </p>
              <Link to="/portfolio/shadower">View Case Study</Link>
            </div>
            <div className={s.laptopPreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/shadower-mockup-macbook2019.png"
              />
            </div>
          </div>

          <div className={s.marcMarmelProjectContainer}>
            <div className={s.marcMarmelProject}>
              <div className={s.laptopPreview}>
                <img
                  alt="Concept Drawn"
                  src="/images/uncompressed/marcmarmel-mockup-macbook1.png"
                />
              </div>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <h3>Marc Marmel</h3>
                </div>
                <h4>Luxury cracked-leather goods</h4>
                <div className={s.tags}>
                  <div className={s.tag}>Website</div>
                  <div className={s.tag}>PHP</div>
                </div>
                <p>
                  Marc Marmel was inspired to launch a handbag line after a trip
                  to the French Riviera when he saw a gap in the market for
                  travel luggage that evoked the jet-setting golden era of
                  travel.
                </p>
                <Link to="/portfolio/marc-marmel">View Case Study</Link>
              </div>
            </div>
          </div>

          <div className={s.saraProjectContainer}>
            <div className={s.saraProject}>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <img alt="sara logo" src={saraLogoWhite} />
                  <h3>SARA</h3>
                </div>
                <h4>Innovative technology partners</h4>
                <div className={s.tags}>
                  <div className={s.tag}>Website</div>
                  <div className={s.tag}>PHP</div>
                </div>
                <p>
                  Innovative technology pioneers developing cutting-edge
                  solutions to the latest challenges, swiftly and at
                  small-business rates. To put it simply, SARA quickly creates
                  while others only imagine.
                </p>
                <Link to="/portfolio/sara">View Case Study</Link>
              </div>
              <div className={s.laptopPreview}>
                <img
                  alt="Concept Drawn"
                  src="/images/uncompressed/sara-mockup-macbook2019.png"
                />
              </div>
            </div>
          </div>

          <div className={s.inheritanceSalvageProjectContainer}>
            <div className={s.inheritanceSalvageProject}>
              <div className={s.laptopPreview}>
                <img
                  alt="Concept Drawn"
                  src="/images/uncompressed/inheritancesalvage-mockup-macbook2019.png"
                />
              </div>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <h3>Inheritance Salvage</h3>
                </div>
                <h4>Hidden jems from our store to your home</h4>
                <div className={s.tags}>
                  <div className={s.tag}>Website</div>
                  <div className={s.tag}>Javascript</div>
                </div>
                <p>
                  Inheritance Salvage is much more than a junk store. We are a
                  retail shop that specializes in Vintage, Antique and
                  Repurposed Decor and Furniture.
                </p>
                <a href="/portfolio/inheritance-salvage">View Case Study</a>
              </div>
            </div>
          </div>

          <div className={s.sunWellnessProjectContainer}>
            <div className={s.sunWellnessProject}>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <h3>Sun Wellness</h3>
                </div>
                <h4>API for calendar integration</h4>
                <div className={s.tags}>
                  <div className={s.tag}>API</div>
                  <div className={s.tag}>Node.js</div>
                </div>
                <p>
                  Sun Wellness wanted a way to sync their booking system with
                  Google Calendar so that their employees could more easily
                  understand when clients would be in a given room.
                </p>
                <Link to="/portfolio/sun-wellness">View Case Study</Link>
              </div>
              <div className={s.laptopPreview}>
                <img
                  alt="Concept Drawn"
                  src="/images/uncompressed/calendar-abstract1.png"
                />
              </div>
            </div>
          </div>

          <div className={s.grayscaleProjectContainer}>
            <div className={s.grayscaleProject}>
              <div className={s.laptopPreview}>
                <img
                  alt="Concept Drawn"
                  src="/images/uncompressed/grayscale-mockup-macbook2019.png"
                />
              </div>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <h3>Grayscale</h3>
                </div>
                <h4>Explore a city of unhinged robots</h4>
                <div className={s.tags}>
                  <div className={s.tag}>Video Game</div>
                  <div className={s.tag}>Unity Engine</div>
                </div>
                <p>
                  A new sentient robot arrives in BlackPort; the Player. With no
                  knowledge of his own creation he must venture out to find
                  answers.
                </p>
                <Link to="/portfolio/grayscale">View Case Study</Link>
              </div>
            </div>
          </div>

          <div className={s.cookieCruncherContainer}>
            <div className={s.cookieCruncherProject}>
              <div className={s.infoContainer}>
                <div className={s.logoContainer}>
                  <h3>Cookie Cruncher</h3>
                </div>
                <h4>The ultimate cookie destruction game</h4>
                <div className={s.tags}>
                  <div className={s.tag}>App</div>
                  <div className={s.tag}>Unity Engine</div>
                </div>
                <p>
                  Cookie Cruncher is an epic cookie-destruction game. Become the
                  head of the Anti-Cookie Activists and lead them down your own
                  chosen path to victory! Complete gameplay challenges to earn
                  in-game money and prove your value.
                </p>
                <Link to="/portfolio/cookie-cruncher">View Case Study</Link>
              </div>
              <div className={s.laptopPreview}>
                <img
                  alt="Concept Drawn"
                  src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9025bd1ae6cffa3ad709aa/1536173692168/iPhoneX-CC-07.png?format=1000w"
                />
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(Portfolio);
